export {};

function setStyles(element: HTMLElement, styles: Partial<CSSStyleDeclaration>): void {
  Object.assign(element.style, styles);
}

function enhancePlaceSearch(): void {
  const wrap = document.querySelector<HTMLElement>(".place-search-wrap");
  const oldBackdrop = document.querySelector<HTMLElement>(".runtime-place-backdrop");

  if (!wrap) {
    oldBackdrop?.remove();
    document.documentElement.style.overflow = "";
    return;
  }

  document.documentElement.style.overflow = "hidden";

  let backdrop = oldBackdrop;
  if (!backdrop) {
    backdrop = document.createElement("div");
    backdrop.className = "runtime-place-backdrop";
    backdrop.dataset.action = "hide-place-search";
    wrap.insertAdjacentElement("beforebegin", backdrop);
  }
  setStyles(backdrop, {
    position: "fixed",
    zIndex: "80",
    inset: "0",
    background: "rgba(12,35,42,.48)",
    backdropFilter: "blur(4px)",
  });

  setStyles(wrap, {
    position: "fixed",
    zIndex: "120",
    top: "50%",
    left: "50%",
    width: "min(calc(100vw - 32px), 500px)",
    maxHeight: "min(78dvh, 620px)",
    overflowY: "auto",
    margin: "0",
    padding: "20px 18px 18px",
    transform: "translate(-50%, -50%)",
    border: "1px solid rgba(36,91,105,.14)",
    borderRadius: "24px",
    background: "#f9fdfd",
    boxShadow: "0 24px 80px rgba(8,34,42,.30)",
  });
  wrap.setAttribute("role", "dialog");
  wrap.setAttribute("aria-modal", "true");
  wrap.setAttribute("aria-label", "場所を選ぶ");

  if (!wrap.querySelector(".runtime-place-heading")) {
    const heading = document.createElement("div");
    heading.className = "runtime-place-heading";
    heading.innerHTML = '<span>撮影場所</span><strong>場所を選ぶ</strong><p>市区町村名や地名を入力して、候補から撮影場所を選んでください。</p>';
    wrap.insertAdjacentElement("afterbegin", heading);
    setStyles(heading, { marginBottom: "14px" });
    const label = heading.querySelector<HTMLElement>("span");
    const title = heading.querySelector<HTMLElement>("strong");
    const lead = heading.querySelector<HTMLElement>("p");
    if (label) setStyles(label, { display: "block", color: "#1985a5", fontSize: ".70rem", fontWeight: "800", letterSpacing: ".08em", marginBottom: "3px" });
    if (title) setStyles(title, { display: "block", color: "#183039", fontSize: "1.22rem", fontWeight: "800", marginBottom: "7px" });
    if (lead) setStyles(lead, { margin: "0", color: "#647c84", fontSize: ".80rem", lineHeight: "1.6" });
  }

  const results = wrap.querySelector<HTMLElement>(".place-results");
  if (results) setStyles(results, { maxHeight: "34dvh", overflowY: "auto" });
}

const observer = new MutationObserver(() => enhancePlaceSearch());
observer.observe(document.documentElement, { childList: true, subtree: true });
queueMicrotask(enhancePlaceSearch);
